import {httpGet, httpPost} from "../libs/http";

export const adminLoadCacheData = (onSuccess = null, onFailure = null) => dispatch => {
    httpGet('/admin/cache/list/', (res) => onSuccess(res), (err) => onFailure(err));
};

export const adminRebuildCache = (data, onSuccess = null, onFailure = null) => dispatch => {
    httpPost('/admin/cache/run-update/', data, (res) => onSuccess(res), (err) => onFailure(err));
};